import { SvgIconTypeMap } from '@material-ui/core';
import { OverridableComponent } from '@material-ui/core/OverridableComponent';
import InformationCircle from 'src/components/icons/InformationCircle';
import ChartSquareBarIcon from '../../components/icons/ChartSquareBar';

export interface MenuReports {
  id: number;
  title: string;
  path: string;
  Icon: OverridableComponent<SvgIconTypeMap<{}, 'svg'>>;
}

export interface MenuReportItem {
  id: number;
  title: string;
  minimo: number;
  medio: number;
  maximo: number;
}

const DataMenuReports: MenuReports[] = [
  {
    id: 12,
    title: 'Gestión Operativa',
    path: '/admin/gestion-operativa',
    Icon: InformationCircle,
  },
  {
    id: 13,
    title: 'Gestión Por Subgerente Y JDN',
    path: '/admin/gestion-subgerente-jdn',
    Icon: InformationCircle,
  },
  {
    id: 3,
    title: 'Avance Mensual Convenios',
    path: '/admin/avance-mensual',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 2,
    title: 'Seguimiento de Convenios',
    path: '/admin/seguimiento',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 4,
    title: 'Avance Acumulados',
    path: '/admin/avance-acumulado',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 5,
    title: 'Proyección de Facturación',
    path: '/admin/proyeccion',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 7,
    title: 'KPI - Remesa',
    path: '/admin/kpi-remesa',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 6,
    title: 'KPI - Tuberia',
    path: '/admin/kpi-tuberia',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 1,
    title: 'Prospección de Ventas',
    path: '/admin/prospeccion',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 8,
    title: 'Evolutivos Prestamos Convenios',
    path: '/admin/evolutivo',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 9,
    title: 'Seguimiento Convenios - Oficina',
    path: '/admin/seguimiento-oficina',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 10,
    title: 'Seguimiento Convenios - Territorio',
    path: '/admin/seguimiento-territorio',
    Icon: ChartSquareBarIcon,
  },
  {
    id: 11,
    title: 'Curva Producción',
    path: '/admin/curva-produccion',
    Icon: ChartSquareBarIcon,
  },
];

export default DataMenuReports;
